
import { useEffect, useState } from "react";
import swal from "sweetalert";
import Hearder from "../commun/Hearder";
import SideBar from "../commun/SideBar";
import { BasicPropoertysaveApi, getBasicPropertydetails } from "../../Services/Service";

const PropertyDetails = () => {
  const [logoFile, setLogoFile] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const [propertyData, setPropertyData] = useState({
    PropertyName: "",
    DisplayName: "",
    Description: "",
    PropertyType: "",
    StarRating: "",
    ChainName: "",
    BuiltYear: "",
    NoofRestaurant: "",
    NoOfRooms: "",
    NoOfFloors: "",
    Currency: "",
    VCCCurrency: "",
    CheckinTime: "",
    CheckoutTime: "",
    Timezone: "",
    CheckIn_24Hrs: "",
    ShortName: "",
    PropertyCode: "",
    PMS: "",
    IsPMS: "",
  });

  useEffect(() => {
    const getPropertydetail = async () => {
      setLoading(true);
      try {
        const result = await getBasicPropertydetails();
        if (result && result.length > 0) {
          setPropertyData(result[0]);

          if (result[0].PropertyLogoURL) {
            setLogoUrl(result[0].PropertyLogoURL);
          }
        }
      }
      catch (error) {
        console.log("eror geting data property detail", error);
      }
      finally {
        setLoading(false);
      }
    }
    getPropertydetail();
  }, []);



  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    try {
      console.log("detaildata", propertyData);
      const result = await BasicPropoertysaveApi(propertyData, logoFile);
      console.log("Saved successfully:", result);
      swal("Property details saved successfully!", {
        icon: "success",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-success",
          },
        },
      });
    } catch (error) {
      alert("Failed to save property details.");
    } finally {
      setLoading(false);
    }
  };


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
    }
  };

  return (
    <>
      {loading && (
        <div className="fullscreen-loader">
          <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
        </div>
      )}

      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />
          <div className="container">
            <div className="page-inner">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Property Details</div>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          {/* Property Name & Display Name */}
                          <div className="col-md-6">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Property Name</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Property Name"
                                value={propertyData.PropertyName}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, PropertyName: e.target.value })
                                }
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Display Name</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Display Name"
                                value={propertyData.DisplayName}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, DisplayName: e.target.value })
                                }
                                required
                              />
                            </div>
                          </div>

                          {/* Description & Property Type */}
                          <div className="col-md-12">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Description</label>
                              <textarea
                                rows="2"
                                className="form-control"
                                placeholder="Enter Description"
                                value={propertyData.Description}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, Description: e.target.value })
                                }
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Property Type</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Property Type"
                                value={propertyData.PropertyType}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, PropertyType: e.target.value })
                                }
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Short Name</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Short Name"
                                value={propertyData.ShortName || ""}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, ShortName: e.target.value })
                                }
                              />

                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Property Code</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Property Code"
                                value={propertyData.PropertyCode || ""}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, PropertyCode: e.target.value })
                                }
                              />

                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">PMS Status</label>
                              <select
                                className="form-control form-select"
                                value={propertyData.IsPMS}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, IsPMS: e.target.value })
                                }
                              >
                                <option value="">Select Status</option>
                                <option value="1">True</option>
                                <option value="0">False</option>
                              </select>

                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">PMS</label>
                              <select
                                className="form-control form-select"
                                value={propertyData.PMS || ""}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, PMS: e.target.value })
                                }
                              >
                                <option value="">Select PMS</option>
                                <option value="Opera">Opera</option>
                                <option value="IdsNext">IdsNext</option>
                              </select>

                            </div>
                          </div>

                          {/* Star Rating & Chain Name */}
                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Star Rating</label>
                              <select className="form-select form-control" value={propertyData.StarRating}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, StarRating: e.target.value })
                                }>
                                <option value="">No Rating</option>
                                <option value="*">1 Star</option>
                                <option value="**">2 Stars</option>
                                <option value="***">3 Stars</option>
                                <option value="****">4 Stars</option>
                                <option value="*****">5 Stars</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Chain Name</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Chain Name"
                                value={propertyData.ChainName}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, ChainName: e.target.value })
                                }
                              />
                            </div>
                          </div>

                          {/* Built Year & No. of Restaurants */}
                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Built Year</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Built Year"
                                value={propertyData.BuiltYear}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, BuiltYear: e.target.value })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">No. of Restaurants</label>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="0"
                                min={0}
                                value={propertyData.NoofRestaurant}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, NoofRestaurant: e.target.value })
                                }
                              />
                            </div>
                          </div>

                          {/* No Of Rooms & No Of Floors */}
                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">No Of Rooms</label>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="0"
                                min={0}
                                value={propertyData.NoOfRooms}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, NoOfRooms: e.target.value })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">No Of Floors</label>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="0"
                                min={0}
                                value={propertyData.NoOfFloors}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, NoOfFloors: e.target.value })
                                }
                              />
                            </div>
                          </div>

                          {/* Currency & VCC Currency */}
                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Currency</label>
                              <select className="form-select form-control" value={propertyData.Currency}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, Currency: e.target.value })
                                }>
                                <option>INR</option>
                                <option>USD</option>
                                <option>EUR</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">VCC Currency</label>
                              <select className="form-select form-control" value={propertyData.VCCCurrency}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, VCCCurrency: e.target.value })
                                }>
                                <option>INR</option>
                                <option>USD</option>
                                <option>EUR</option>
                              </select>
                            </div>
                          </div>

                          {/* Check-in Time & Checkout Time */}
                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Check-in Time</label>
                              <input
                                type="time"
                                className="form-control"
                                placeholder="Enter Check-in Time"
                                value={
                                  propertyData.CheckinTime
                                    ? `${propertyData.CheckinTime.slice(0, 2)}:${propertyData.CheckinTime.slice(2)}`
                                    : ""
                                }
                                onChange={(e) =>
                                  setPropertyData({
                                    ...propertyData,
                                    CheckinTime: e.target.value.replace(":", ""),
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Checkout Time</label>
                              <input
                                type="time"
                                className="form-control"
                                placeholder="Enter Checkout Time"
                                value={
                                  propertyData.CheckoutTime
                                    ? `${propertyData.CheckoutTime.slice(0, 2)}:${propertyData.CheckoutTime.slice(2)}`
                                    : ""
                                }
                                onChange={(e) =>
                                  setPropertyData({
                                    ...propertyData,
                                    CheckoutTime: e.target.value.replace(":", ""),
                                  })
                                }
                              />
                            </div>
                          </div>

                          {/* Timezone & 24 Hrs Check-in */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Timezone</label>
                              <select className="form-select form-control" id="Timezone" value={propertyData.Timezone}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, Timezone: e.target.value })
                                }>
                                <option value="Etc/GMT+12">(UTC-12:00) International Date Line West</option>
                                <option value="Pacific/Midway">(UTC-11:00) Midway Island, Samoa</option>
                                <option value="Pacific/Honolulu">(UTC-10:00) Hawaii</option>
                                <option value="America/Anchorage">(UTC-09:00) Alaska</option>
                                <option value="America/Los_Angeles">(UTC-08:00) Pacific Time (US & Canada)</option>
                                <option value="America/Denver">(UTC-07:00) Mountain Time (US & Canada)</option>
                                <option value="America/Chicago">(UTC-06:00) Central Time (US & Canada)</option>
                                <option value="America/New_York">(UTC-05:00) Eastern Time (US & Canada)</option>
                                <option value="America/Halifax">(UTC-04:00) Atlantic Time (Canada)</option>
                                <option value="America/Argentina/Buenos_Aires">(UTC-03:00) Buenos Aires</option>
                                <option value="America/Noronha">(UTC-02:00) Mid-Atlantic</option>
                                <option value="Atlantic/Azores">(UTC-01:00) Azores</option>
                                <option value="Europe/London">(UTC+00:00) London, Lisbon</option>
                                <option value="Europe/Berlin">(UTC+01:00) Berlin, Rome, Paris</option>
                                <option value="Europe/Athens">(UTC+02:00) Athens, Cairo</option>
                                <option value="Europe/Moscow">(UTC+03:00) Moscow, Nairobi</option>
                                <option value="Asia/Tehran">(UTC+03:30) Tehran</option>
                                <option value="Asia/Dubai">(UTC+04:00) Abu Dhabi, Baku</option>
                                <option value="Asia/Karachi">(UTC+05:00) Islamabad, Karachi</option>
                                <option value="Asia/Kolkata">(UTC+05:30) India Standard Time</option>
                                <option value="Asia/Dhaka">(UTC+06:00) Almaty, Dhaka</option>
                                <option value="Asia/Bangkok">(UTC+07:00) Bangkok, Jakarta</option>
                                <option value="Asia/Shanghai">(UTC+08:00) Beijing, Singapore</option>
                                <option value="Asia/Tokyo">(UTC+09:00) Tokyo, Seoul</option>
                                <option value="Australia/Sydney">(UTC+10:00) Sydney, Guam</option>
                                <option value="Pacific/Auckland">(UTC+12:00) Auckland, Fiji</option>
                              </select>

                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">24 Hrs Check-in</label>
                              <select className="form-select form-control" value={propertyData.CheckIn_24Hrs}
                                onChange={(e) =>
                                  setPropertyData({ ...propertyData, CheckIn_24Hrs: e.target.value })
                                }>
                                <option>Select</option>
                                <option>Yes</option>
                                <option>No</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* Logo Upload */}
                        <div className="col-12 mb-3">
                          <div className="d-flex gap-3 flex-wrap">
                            {(logoFile || logoUrl) && (
                              <div
                                style={{
                                  width: "89px",
                                  height: "62px",
                                  borderRadius: "10px",
                                  overflow: "hidden",
                                  position: "relative",
                                }}
                              >
                                <img
                                  src={logoFile ? URL.createObjectURL(logoFile) : logoUrl} // 👈 agar naya upload hai to wo, warna API ka URL
                                  alt="preview"
                                  style={{ width: "100%", height: "100%", objectFit: "cover", }}
                                />
                                <button
                                  type="button"
                                  onClick={() => {
                                    setLogoFile(null);
                                    setLogoUrl(null);
                                  }}
                                  style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    background: "#fff",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: "24px",
                                    height: "24px",
                                    padding: 0,
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    color: "#333",
                                    cursor: "pointer",
                                    boxShadow: "0 0 5px rgba(0,0,0,0.2)",
                                  }}
                                >
                                  ×
                                </button>
                              </div>
                            )}


                            {/* Upload Box */}
                            <label
                              htmlFor="imageUpload"
                              style={{
                                width: "89px",
                                height: "62px",
                                border: "2px dashed #ccc",
                                borderRadius: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                            >
                              <div style={{ textAlign: "center", color: "#999" }}>
                                <i
                                  className="fas fa-image"
                                  style={{ fontSize: "20px" }}
                                ></i>
                                <br />
                                {logoFile ? "Change Logo" : "Add Logo"}
                              </div>
                              <input
                                type="file"
                                id="imageUpload"
                                accept="image/*"
                                onChange={handleImageChange}
                                style={{ display: "none" }}
                              />
                            </label>
                          </div>
                        </div>

                        {/* Submit Button */}
                        <div className="card-action text-end">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

    </>
  )
}

export default PropertyDetails;
